"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("actionHistorys").controller("ActionHistorysCtrl", ActionHistorysCtrl).component("actionHistories", {
    templateUrl: "app/pages/actionHistories/actionHistories.html",
    bindings: {
      resolve: "<?"
    },
    //transclude: true,
    controller: ActionHistorysCtrl
  });

  function ActionHistorysCtrl($rootScope, $scope, $controller, $timeout, AgGridService, UsersService, ActionHistoriesService) {
    var vm = this;
    vm.ctrlName = "ActionHistorysCtrl";

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: ActionHistoriesService,
      params: {
        editPage: ""
      }
    });

    vm.isSuperAdmin = ["super-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.columnDefs = [AgGridService.text("userName", "Utilisateur"), AgGridService.date("date", "Date"), AgGridService.hour("date", "Heure"), AgGridService.text("action", "Action")];

    vm.gridEvent = function (value) {
      console.log(value);

      if (value.type == "rowDoubleClicked") {
        vm.edit(value.data);
      }
    };

    vm.close = function () {
      console.log("$scope", $scope);
      if ($scope.$parent) {
        $scope.$parent.$close();
      }
    };

    vm.refresh = function (params) {
      var _this = this;

      if (!vm.isSuperAdmin) {
        $rootScope.$broadcast("auth_not_authorized");
        return;
      }

      console.log("refresh actionHistorys");

      vm.from = moment().subtract(7, "days").startOf("day").toDate();
      vm.to = moment().endOf("day").toDate();

      var where = { date: { $gte: vm.from, $lte: vm.to } };

      Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
      ActionHistoriesService.load(null, false, null, where).then(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(actionHistories) {
          var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, actionHistory;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  vm.rawData = [];
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context.prev = 4;
                  _iterator = actionHistories[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context.next = 16;
                    break;
                  }

                  actionHistory = _step.value;
                  _context.next = 10;
                  return UsersService.getNameById(actionHistory.userId);

                case 10:
                  actionHistory.userName = _context.sent;

                  actionHistory.action = actionHistory.action ? actionHistory.action.split("?")[0] : "";
                  vm.rawData.push(actionHistory);

                case 13:
                  _iteratorNormalCompletion = true;
                  _context.next = 6;
                  break;

                case 16:
                  _context.next = 22;
                  break;

                case 18:
                  _context.prev = 18;
                  _context.t0 = _context["catch"](4);
                  _didIteratorError = true;
                  _iteratorError = _context.t0;

                case 22:
                  _context.prev = 22;
                  _context.prev = 23;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 25:
                  _context.prev = 25;

                  if (!_didIteratorError) {
                    _context.next = 28;
                    break;
                  }

                  throw _iteratorError;

                case 28:
                  return _context.finish(25);

                case 29:
                  return _context.finish(22);

                case 30:

                  Notiflix.Loading.remove();
                  $timeout(function () {
                    vm.needToBeUpdate = true;
                  });

                case 32:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this, [[4, 18, 22, 30], [23,, 25, 29]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        Notiflix.Loading.remove();
      });
    };

    vm.refresh();
  }
})();